import { type RouteRecordRaw } from 'vue-router';
import Breadcrumbs from './breadcrumb';

const Appointments = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Appointments" */ '@/pages/Index');
const RequestNewAppointment = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RequestNewAppointment" */ '@/pages/RequestNewAppointment/requestNewAppointment');
const AppointmentDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AppointmentDetails" */ '@/pages/AppointmentDetails/appointmentDetails');
const AppointmentValidation = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "AppointmentValidation" */ '@/pages/AppointmentValidation/appointmentValidation');

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'appointments',
    component: Appointments,
    meta: {
      breadcrumb: Breadcrumbs.appointments,
      highlighted: true,
    },
  },
  {
    path: '/request-new-appointment',
    name: 'RequestNewAppointment',
    component: RequestNewAppointment,
    meta: {
      breadcrumb: Breadcrumbs.requestNewAppointment,
      highlighted: true,
    },
  },
  {
    path: '/appointment-details/:externalId',
    name: 'AppointmentDetails',
    component: AppointmentDetails,
    meta: {
      breadcrumb: Breadcrumbs.appointmentDetails,
      highlighted: true,
    },
  },
  {
    path: '/validation/:externalId',
    name: 'AppointmentValidation',
    component: AppointmentValidation,
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/',
  // },
];

export default routes;
